import React from "react";
import { Link } from "react-router-dom";

const Navbar = ({ buttonAction }) => {
  return (
    <header className="w-full bg-white">
      <nav className="mx-auto flex w-full max-w-[1200px] items-center justify-between px-4 py-5">
        <Link to="/" className="flex items-center gap-3">
          <img
            className="h-12 w-12 object-contain sm:h-14 sm:w-14"
            src="/images/ball_logo.png"
            alt="Student Ball logo"
          />

          <div>
            <h1 className="text-xl font-extrabold uppercase tracking-wide text-slate-900 sm:text-3xl">
              Student Ball
            </h1>
            <p className="hidden text-sm font-medium text-blue-600 sm:block">
              Make your moments matter.
            </p>
          </div>
        </Link>

        <button
          to="/"
          className="hidden rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-600 md:inline-flex"
          onClick={buttonAction}
        >
          Book Highlights
        </button>
      </nav>
    </header>
  );
};

export default Navbar;